<template>
    <span>{{ formatted }}</span>
</template>

<script>
export default {
    props   : ['date', 'time'],
    computed: {
        formatted () {

            if (this.time) {
                const t = new Date(this.time);

                return t.toLocaleString('en-us', { 
                    timeZone: 'UTC',
                    hour    : 'numeric',
                    minute  : 'numeric'
                });
            }

            const d = new Date(this.date);

            return `${d.toLocaleString('en-us', { timeZone: 'UTC', weekday: 'long'})} 
            ${d.toLocaleString('en-us', { 
        timeZone: 'UTC',
        month   : 'numeric',
    })}/${d.toLocaleString('en-us', { 
    timeZone: 'UTC',
    day     : 'numeric',
})}/${d.toLocaleString('en-us', { 
    timeZone: 'UTC',
    year    : 'numeric',
})}`;
        }
    }
};
</script>